import { render, staticRenderFns } from "./FormLiffDesign.vue?vue&type=template&id=5d787738&scoped=true&"
import script from "./FormLiffDesign.vue?vue&type=script&lang=js&"
export * from "./FormLiffDesign.vue?vue&type=script&lang=js&"
import style0 from "./FormLiffDesign.vue?vue&type=style&index=0&id=5d787738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d787738",
  null
  
)

export default component.exports